<template xmlns:v="http://www.w3.org/1999/html">
    <div class="shop">


        <div class="main">
            <img src="@/assets/kompass.svg" class="kompass">
            <div id="map" v-if="canBeNavigated">
                <HausNavigation active="houses"></HausNavigation>
                <MapCanvas :startpoint="startLocation" :endpoint="endpoint" :nodes="nodes"></MapCanvas>
                <MapStartIcon type="start" :top="getStartNode.y" :left="getStartNode.x"></MapStartIcon>
                <MapStartIcon type="end" :top="getEndLocation.y" :left="getEndLocation.x"></MapStartIcon>

                <div class="service-points">
                    <ServicePoint :dataid="key" :type="point.type" :position="point.position" :fill="point.fill" v-for="(point, key) in activeServicePoints"></ServicePoint>
                </div>
                <!--                <HausNavigation active="icons"></HausNavigation>-->
            </div>
            <router-link v-if="backlink" :to="backlink" class="backlink button"><img alt="" src="@/assets/chevleft.svg"> {{languageStrings['Übersicht']}}</router-link>
            <div id="restart" class="newloadbutton" v-if="shop"><img src="@/assets/reloadicon.svg">{{languageStrings['Neu Laden']}} </div>
            <div class="error" v-if="!canBeNavigated">Es ist ein Fehler aufgetreten.<br> Oops, something went wrong</div>
        </div>


        <div class="left">
            <h2>{{languageStrings['Wegbeschreibung']}}</h2>
            <div class="main-desc" :class="'h'+endpointParsed.house">
                <span class="icon pulsate-fwd" :class="'orient-' + getOrientation" ><img alt="" class="" src="@/assets/navigationArrowLg.svg"></span>
                <div class="text"> {{textDescription}}</div>
            </div>
            <hr>
            <div class="shoplocation"><img alt="" class="icon" src="@/assets/pingray.svg"><span v-html="shop.name"></span>, <span class="capitalise">{{languageStrings['haus']}}</span> {{shop.house}}, <span class="capitalise">{{languageStrings['Ebene']}}</span> {{shop.level}} </div>
            <div class="shop-directions-1">
                <img alt="" class="icon" src="@/assets/walkingman.svg">
                <span>{{timeRequired}}</span>
                <span class="divider"></span>
                <div class="levelchange" v-if="levelChange">
                    <img src="@/assets/levelchangeup.svg" v-if="levelChange == 'up'">
                    <img src="@/assets/levelchangedown.svg" v-if="levelChange == 'down'">

                    <span class="d-landscape">{{languageStrings['Ebene']}} {{startPointParsed.level}} <img alt="" class="arrow" src="@/assets/navichevright.svg"></span> {{languageStrings['Ebene']}} {{endpointParsed.level}}
                </div>

            </div>
            <div class="shop-directions-2">
                <img alt="" class="icon" src="@/assets/homegray.svg">
                <div class="houses">
                    <div class="house" v-for="house in getDirectionHouses" :class="['h'+house.house, house.direction]"></div>
                </div>
            </div>
            <hr class="secondhr">
            <div class="servicepoints-container">
                <h3>{{languageStrings['Servicepoints Anzeigen']}}</h3>
                <div class="servicePoints">
                    <div @click=" selectServicePoint('toilet')" :class="{ activeSP : selectedServicePoints == 'toilet' }">
                        <service-point  :type="'toilet'" :position="{x:0,y:0}"></service-point>
                    </div>
                    <div @click="selectServicePoint('info')" :class="{ activeSP : selectedServicePoints == 'info' }">
                        <service-point  :type="'info'" :position="{x:0,y:0}"></service-point>
                    </div>
                    <div @click="selectServicePoint('bank')" :class="{ activeSP : selectedServicePoints == 'bank' }">
                        <service-point :type="'bank'" :position="{x:0,y:0}"></service-point>
                    </div>
                    <div @click="selectServicePoint('lock')" :class="{ activeSP : selectedServicePoints == 'lock' }">
                        <service-point :type="'lock'" :position="{x:0,y:0}"></service-point>
                    </div>
                    <div @click="selectServicePoint('lift')" :class="{ activeSP : selectedServicePoints == 'lift' }">
                        <service-point :type="'lift'" :position="{x:0,y:0}"></service-point>
                    </div>
                    <div @click="selectServicePoint('parkdeck')" :class="{ activeSP : selectedServicePoints == 'parkdeck' }">
                        <service-point :type="'parkdeckmain'" :position="{x:0,y:0}"></service-point>
                    </div>
                </div>
            </div>

            <div class="weblocation" v-if="options.isWebView || options.isDetailView">
                <h3>Startpunkt</h3>
                <select v-on:change="setStartLocation(this)" v-model="webStartSelect">
                    <option v-for="option in startpoints" :value="option.slug">Ebene {{option.id.substring(1,2)}}, Haus {{option.id.substring(2,3)}}</option>
                </select>
            </div>
        </div>
    </div>

</template>

<script>
// @ is an alias to /src
import { gsap } from 'gsap';
// import HausAll from '@/components/HausAll.vue'
import HausNavigation from '@/components/HouseNavigation.vue'
import MapStartIcon from '@/components/MapStartIcon.vue'
import MapCanvas from '@/components/MapCanvas.vue'
import ServicePoint from '@/components/ServicePoint.vue'
import { nodes, servicePoints, getActiveHouses, getDirectionHouses, navigate, startDescriptions, parseNode } from '@/nodes.js'

export default {
    name: 'ShopDetails',
    components: {MapStartIcon, HausNavigation, MapCanvas, ServicePoint},
    data() {
        return {
            backlink: this.$route.params.backlink,
            id: this.$route.params.id,
            nodes: [],
            selectedServicePoints: false,
            hasError: false,
            getDirectionHouses: [],
            webStartLocations: [
                {node: 'h11', name: 'Ebene 1, Haus 1'},
                {node: 'h21', name: 'Ebene 2, Haus 1'},
            ],
            webStartSelect: false,
            startLocation: false,
            activeHouses: false,
            routes: false,
            LangElementsDE: '#Hausbeschreibung > *, #Entrances > *',
            LangElementsEN: '#Hausbeschreibung-englisch > *, #Entrances-englisch > *',
            textDescription: ''
        }
    },
    props: ['store', 'languageStrings', 'options', 'houseColors', 'currentLanguage'],
    created() {
        this.nodes = nodes;
        this.servicePoints = servicePoints;
        this.startDescriptions = startDescriptions;
        this.startLocation = this.options.location;
        this.routes = navigate(this.startLocation, this.endLocation)
        this.webStartSelect = this.nodes.find(x => x.id === this.startLocation).slug

    },
    computed: {
        activeLangElements(){
            if (this.currentLanguage == 'de'){
                return this.LangElementsDE
            } else if (this.currentLanguage == 'en' ){
                return this.LangElementsEN
            }
        },
        startpoints() {
            return this.nodes.filter(x=> x.isStartpoint == true)
        },
        color() {
            return this.houseColors.find(x=> x.id == this.endpoint.substring(2,3)).color;
        },
        svgHouseID(){
            return 'haus' + this.endpoint.substring(1,3);
        },
        svgStartHouseID(){
            return 'haus' + this.startPointParsed.level + this.startPointParsed.house
        },
        shop(){
            if (this.id != 'servicepoint'){
                return this.store.shops.filter(x=>x.id == this.id)[0]
            } else return false

        },

        exits(){
            let exits = [];
            let v = this;
            if (this.shop){
                this.shop.shopnumbers.forEach(function (shop) {
                    if ( v.store.exits[shop] ){
                        exits.push(v.store.exits[shop])
                    }
                })
            }

            return exits;
        },
        endpoint(){
            // retuns the best endpoint with fallbacks
            let endpoints = [];
            let v = this;

            if (this.shop){
                this.shop.shopnumbers.forEach(function (shopnumber) {
                    if ( v.store.exits[shopnumber] ){
                        endpoints.push(v.store.exits[shopnumber])
                    }
                })

                // let endpoints = this.store.exits[]
                // let endpoints = this.store.exits.find(x=> x.substring(1,2) == v.bestLevel )
                // endpoints.forEach();
                let endpoint = false;

                if (endpoints.length > 1){
                    endpoints.forEach(function (point) {
                        if (point.substring(1,2) == v.location.level){
                            endpoint = point;
                        }
                    })
                }

                if ( !endpoint && endpoints.length === 1 ){
                    return endpoints[0]
                }

                if ( !endpoint ){
                    endpoint = 'h'+this.shop.shopnumbers[0].substring(2,3)+this.shop.shopnumbers[0].substring(0,1);
                    return endpoint;
                }

                return endpoint;
            }
        },
        getEndLocation(){
            // gets the endpoint node object
            if (this.shop){
                let v = this;
                let endlocal = this.nodes.find(x => x.id == v.endpoint)
                if (endlocal) {
                    return endlocal
                } else {
                    return false
                }
            } else return false

        },
        getStartNode(){
            //retuns the startnode object
            let v = this;
            return this.nodes.find(x => x.id == v.startLocation)
        },
        activeServicePoints(){
            //filters the visible service icons
            let v = this;
            return this.servicePoints.filter(x=> x.type == v.selectedServicePoints)
        },
        timeRequired(){
            if (this.shop && this.routes[this.endpoint]){
                return Math.max(this.routes[this.endpoint].length, 3) + ' min';
            }
        },

        getOrientation(){
            if (this.shop){
                let levelchange = this.getDirectionHouses.find(x=> x.direction != false);

                if (this.options.orientation == 'TG') {
                    return 'N';
                }
                else if (this.startPointParsed.house == this.endpointParsed.house && this.startPointParsed.level == this.endpointParsed.level){
                    return 'none'
                }
                else if (levelchange && levelchange.house == this.startPointParsed.house && this.startPointParsed.house == this.endpointParsed.house){
                    return 'none'
                }
                else {
                    let childObject = this.getStartNode.childOrientation.find(x => x.node == this.routes[this.endpoint][0]);
                    if (childObject) {
                        return childObject.orientation
                    } else return false
                }
            } else return false;

        },
        startPointParsed(){
            return parseNode(this.startLocation)
        },
        endpointParsed(){
            return parseNode(this.endpoint)
        },
        levelChange(){
            if (this.getDirectionHouses && this.getDirectionHouses.find(x=> x.direction == 'up') ){
                return 'up';
            } else if(this.getDirectionHouses && this.getDirectionHouses.find(x=> x.direction == 'down')){
                return 'down';
            } else {
                return '';
            }
        },
        canBeNavigated(){
            if ( this.shop && this.exits.length && this.getEndLocation ){
                return true
            } else return false
        },
        nextHaus(){
            if ( this.activeHouses.length > 1 ){
                return 'h'+this.activeHouses[1].substr(2,1)
            } else if ( this.activeHouses.length === 1){
                return 'h'+this.activeHouses[0].substr(2,1)
            }
        }
    },
    methods: {
        startNavigation(){
            let v = this;
            console.log('starting Nav');
            //reset startpoint colour
            //colour map
            let starthouse = document.getElementById(v.svgStartHouseID);

            let color = '';
            if (starthouse){
                if ( this.options.orientation == 'TG' ){
                    color = '#DEDEDE';
                } else {
                    color = this.houseColors.find(x=> x.id == this.startPointParsed.house).color;
                }
                starthouse.style.fill = color;
            }

            document.getElementById(this.svgHouseID).style.fill = this.color;

            // set inital states
            gsap.set('#NavigationExtras circle, #NavigationExtras g', {opacity: 0} )
            gsap.set(this.LangElementsDE, {opacity: 0, scale: 0, transformOrigin: 'center'} )
            gsap.set(this.LangElementsEN, {opacity: 0, scale: 0, transformOrigin: 'center'} )

            // build array of things to turn off becuase Im lazy
            let layers = '';
            for (let i=1; i < 4 ; i++){
                for (let g=1; g < 10; g = g+2){
                    layers += '#keyshop-h'+i+g+',';
                    layers += '#keyshop-h'+i+g+'-active,';
                }
            }
            layers += '#keyshop';

            gsap.set(layers, {opacity: 0} )

            let navigationtimeline = gsap.timeline({paused: false})
            navigationtimeline.from('.startIcon', {duration: 1, opacity: 0}, 0)
            navigationtimeline.to(this.navigationExtras, {duration: 2, opacity: 1}, 0)
            navigationtimeline.from('#conva', {duration: 2, opacity:0}, '-=2')

            let entryTimeline = gsap.timeline();
            entryTimeline.from('#House1', {duration: 1, y: -1600})
            entryTimeline.from('#House2', {duration: 1, y: -1400,}, "-=0.5")
            entryTimeline.from('#House3', {duration: 1, y: -800,}, "-=0.5")
            entryTimeline.from('.kompass', {duration: 1, y: -800,}, "-=1.5")

            if ( !this.options.isPortrait){
                entryTimeline.from('.shop .left', { duration: 1, x: 800 }, "-=1.0")
            }

            entryTimeline.add(navigationtimeline);
            entryTimeline.to(this.activeLangElements, {duration: 1, opacity: 1, scale:1,  ease: "back.out(1.7)", transformOrigin:'center'}, '-=2')
            // entryTimeline.from('#Entrances g', {duration: 1, opacity: 0, scale:0,  ease: "back.out(1.7)", transformOrigin:'center'}, '-=2')

            this.activeHouses.forEach(function (keyshop, key) {
                if (key === 0 || key === v.activeHouses.length - 1){
                    entryTimeline.to('#keyshop-'+keyshop+'-active', {opacity: 1,}, '-=2')
                } else {
                    entryTimeline.to('#keyshop-'+keyshop, {opacity: 1,}, '-=2')
                }
            })

            entryTimeline.from('#restart', {duration: 1, opacity: 0, y: 100}, '-=1')

            let restart = document.querySelector("#restart");
            restart.onclick = function(){
                entryTimeline.restart();
            }
        },
        setStartLocation(){
            window.location.assign(window.location.origin + window.location.pathname + '?website=true&startpoint=' + this.webStartSelect + window.location.hash  )
        },
        selectServicePoint(type){
            document.getElementById('parkdeck-englisch').style.opacity = 0
            document.getElementById('parkdeck').style.opacity = 0
            if (type != this.selectedServicePoints ){
                this.selectedServicePoints = type;
                if (type == 'parkdeck'){
                    if (this.currentLanguage == 'en'){
                        document.getElementById('parkdeck-englisch').style.opacity = 1
                    } else if ( this.currentLanguage == 'de'){
                        document.getElementById('parkdeck').style.opacity = 1
                    }
                }
            } else {
                this.selectedServicePoints = false;

            }

        },
        setStartDescription(){
            let levelchange = this.getDirectionHouses.find(x=> x.direction != false);
            if (this.shop){
                //case TG
                if (this.options.orientation == 'TG'){

                    //override TG5 + TG7 to h39
                    if ( this.startPointParsed.node != 'h09' && this.endpointParsed.node == 'h39' ){
                        return this.languageStrings['WBTG'].replace('%level', levelchange.level) + this.languageStrings['WBTG2'].replace('%house', '9') + this.languageStrings.WBMM;
                        //override TG9 to Ebene 3
                    } else if ( this.startPointParsed.node == 'h09' && this.endpointParsed.level == 3 && this.endpointParsed.house == 9 ) {
                        return this.languageStrings['WBTG'].replace('%level', this.endpointParsed.level);
                        //override TG to Ebene 3 Haus 1
                    } else if ( this.options.orientation == 'TG' && this.endpointParsed.level == 3 && this.endpointParsed.house == 1 ) {
                        return this.languageStrings['WBTG'].replace('%level', this.getDirectionHouses[0].level) + this.languageStrings['WBTG2'].replace('%house', '1') + this.languageStrings.WBTG4 ;
                    } else {
                        //Starthaus und Endhaus ident
                        if ( this.startPointParsed.house == this.endpointParsed.house ) {
                            return this.languageStrings['WBTG'].replace('%level', this.endpointParsed.level) + this.languageStrings['WBTG3'].replace('%house', this.endpointParsed.house)
                        }
                        else {
                            // Starthaus und endhaus nicht ident
                            return this.languageStrings['WBTG'].replace('%level', this.endpointParsed.level) + this.languageStrings['WBTG2'].replace('%house', this.endpointParsed.house)
                        }
                    }
                }

                //case 1 house no levelchange -> Bleiben Sie im Haus X
                else if (this.startPointParsed.house == this.endpointParsed.house && this.startPointParsed.level == this.endpointParsed.level ){
                    return this.languageStrings['Bleiben Sie im haus'] + ' ' + this.startPointParsed.house
                }
                //levelchange in current haus -> Bleiben Sie im Haus X und wechseln Sie in die gewünschte Ebene
                else if ( levelchange && levelchange.house == this.startPointParsed.house && this.endpointParsed.house == this.startPointParsed.house){
                    return this.languageStrings['Bleiben Sie im haus'] + ' ' + this.startPointParsed.house + this.languageStrings['WBLC']
                }

                //case normal -> Starten Sie X Richtung Haus X
                else {
                    let dir = '';

                    if ( this.getOrientation == 'N' ){
                        dir = this.languageStrings.WBN
                    }
                    if ( this.getOrientation == 'E' ){
                        dir = this.languageStrings.WBE
                    }
                    if ( this.getOrientation == 'S' ){
                        dir = this.languageStrings.WBS
                    }
                    if ( this.getOrientation == 'W' ){
                        dir = this.languageStrings.WBW
                    }

                    let string = this.languageStrings['WBLN'].replace('%dir',dir ).replace('%house', this.endpointParsed.house)
                    if ( this.endpointParsed.level != this.startPointParsed.level ){
                        string += ', ' + this.languageStrings['Ebene'] + ' ' + this.endpointParsed.level
                    }
                    return string;
                }
            } else return false;
        },
    },
    watch: {
        currentLanguage: function(newVal, oldVal){
            document.getElementById('parkdeck-englisch').style.opacity = 0
            document.getElementById('parkdeck').style.opacity = 0
            this.selectedServicePoints = false
            this.startNavigation()
            this.textDescription = this.setStartDescription()
        },
    },
    mounted() {
        console.log('mounted');
        if (this.shop){
            this.activeHouses = getActiveHouses(this.startLocation, this.endpoint)
            this.getDirectionHouses = getDirectionHouses(this.startLocation, this.endpoint)
        }

        this.textDescription = this.setStartDescription()
        // this.activeHouses = [];
        if (this.id != 'servicepoint' && this.canBeNavigated){
            this.startNavigation()
        }
    }
}

</script>

<style></style>

<style lang="scss" scoped>
@import "../../styles/variables";

.main {
    position: relative;
}

.kompass {
    position: absolute;
    right: 70px;
    top: 60px;

    @include portrait(){
        right: 40px;
    }
}


h2 {
    color: $gray2;
    margin-bottom: 80px;



}

h3 {
    color: $gray2;
    font-size: 24px;
}

.shop {
    width: 100%;
}

.main-desc {
    display: flex;
    color: $blue;

    &.h3 {
        color: $green;
        .icon {
            background: $green;
        }
    }
    &.h5 {
        color: $purple;
        .icon {
            background: $purple;
        }
    }
    &.h7 {
        color: $yellow;
        .icon {
            background: $yellow;
        }
    }
    &.h9 {
        color: $rose;
        .icon {
            background: $rose;
        }
    }

    .icon {
        width: 103px;
        height: 103px;
        background: $blue;
        border-radius: 14px;
        padding: 13px;
        border-right: 13px;
        margin-right: 20px;
        display: flex;

        &.orient-S{
            img {
                transform: rotate(180deg);
            }
        }

        &.orient-W{
            img {
                transform: rotate(270deg);
            }
        }

        &.orient-E{
            img {
                transform: rotate(90deg);
            }

        }

        &.orient-none{
            img {
                display: none;
            }

        }
    }

    .text {
        font-size: 24px;
        font-weight: 700;
        width: 75%;

        @include portrait(){
            font-size: 18px;
        }

    }

    &.green {
        color: $green;
    }
}

.weblocation {
    margin-top: 40px;
    select {
        /*font-size: 20px;*/
        width: 150px;
        transform: scale(1.5);
        transform-origin: top left;
        position: relative;
        top: -10px;
    }
}

hr {
    /*margin: 30px 0px;*/
    border: none;
    border-bottom: 1px solid #666666;
    margin: 30px 0px;
    &.secondhr {
        @include portrait(){
            display: none;
        }
    }
}

.main {
    padding-top: 0 !important;
    padding-right: 40px !important;
    img.preview {
        width: 100%;
    }
}

$servicepointsPortraitWidth: 38%;

.left {
    width: 677px;
    background: #F6F5F2;
    height: 100%;
    padding: 90px 108px;
    position: relative;
    padding-left: 90px;
    z-index: 5;

    @include portrait(){

        order: 12;
        transform: scale(1.4);
        transform-origin: left top;
        padding: 30px 38px;
        padding-right: $servicepointsPortraitWidth - 5%;
        width: 771px;
        height: 560px;
        bottom: 0px;
    }
}

h2 {
    @include portrait(){
        display: none;
    }
}

.webdetail {
    .left {
        background: none;
    }
}

.newloadbutton {
    font-weight: bold;
    width: 169px;
    height: 50px;
    background: #E25A10;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
    text-transform: uppercase;
    text-decoration: none;
    position: absolute;
    right: 70px;
    bottom: 70px;

    @include portrait(){
        bottom: 32%;
        right: 40px;
    }

    img {
        margin-right: 10px;
    }
}

.main {
    overflow: hidden !important;
}



.levelchange {
    display: flex;
    align-items: center;

    img {
        position: relative;
        top: 0px;
        margin-left: 5px;
        margin-right: 20px;
    }

    .arrow {
        left: 5px;
        top: 0px;
    }
}

.shoplocation {
    font-size: 20px;
    margin-bottom: 20px;
    position: relative;
    padding-left: 45px;
    color: $gray2;

    .icon {
        position: absolute;
        top: 0px;
        left: 0;
        margin-right: 23px;
        width: 25px;
        margin-left: 2px;
    }
}

.backlink {
    bottom: 130px;
    right: 70px;

    @include portrait(){
        display: none;
    }
}

.servicepoints-container {
    position: absolute;
    bottom: 40px;

    @include portrait(){
        position: absolute;
        right: 0px;
        width: $servicepointsPortraitWidth;
        height: 100%;
        top: 20px;

        h3 {
            margin-top: 10px;
        }
    }
}

.servicePoints {
    display: flex;
    justify-content: space-between;
    width: 420px;
    align-items: center;

    > div {
        //margin-right: 20px;
        //margin-bottom: 20px;
        @include buttonActive;
        &:after {
            content: '';
            background: transparent;
            height: 2px;
            display: block;
            position: relative;
            top: 5px;
        }
    }

    @include portrait(){
        flex-wrap: wrap;
        justify-content: flex-start;
        /*align-items: flex-start;*/
        width: 290px;

        > div {
            margin-right: 10px;
            margin-bottom: 5px;
            margin-bottom: 20px;
        }

    }

    .service-point {
        position: relative;
        width: 64px;


    }

    .activeSP:after {
        background: $orange;
    }
}

.shop-directions-1 {
    margin-bottom: 10px;
    display: flex;
    font-size: 20px;
    align-items: center;
    margin-bottom: 20px;
    color: $gray2;

    .icon {
        margin-right: 20px;
        min-width: 21px;
        margin-left: 4px;

        @include portrait(){
            width: 24px;
        }
    }

    .divider {
        margin: 0 28px;
        height: 26px;
        background: $gray2;
        width: 2px;
        display: inline-block;
        @include portrait(){
            margin: 0 10px;
        }
    }
}

.shop-directions-2 {
    display: flex;
    margin-bottom: 40px;
    color: $gray2;

    .icon {
        margin-right: 20px;
    }
    .houses {
        display: flex;
        .house {
            margin: 0px 12px;
            width: 30px;
            height: 30px;
            background: red;
            border-radius: 5px;
            position: relative;

            &.up {
                background-image: url('../../assets/uparrow.svg');
                background-repeat: no-repeat;
                background-position: center;
            }

            &.down {
                background-image: url('../../assets/downarrow.svg');
                background-repeat: no-repeat;
                background-position: center;
            }

            &.h1 {
                background-color: $blue;
            }
            &.h3{
                background-color: $green;
            }
            &.h5 {
                background-color: $purple;
            }
            &.h7 {
                background-color: $yellow;
            }
            &.h9 {
                background-color: $rose;
            }

            &:after {
                width: 17px;
                height: 32px;
                background-image: url(../../assets/navichevright.svg);
                display: block;
                content: '';
                position: absolute;
                right: -18px;
                background-repeat: no-repeat;
                background-position: center;
            }
            &:last-child {
                &:after {
                    content: none;
                }
            }
        }
    }
}

.error {
    position: absolute;
    left: 28%;
    top: 46%;
}

.pulsate-fwd {
    -webkit-animation: pulsate-fwd 1s ease-in-out 3s infinite both;
    animation: pulsate-fwd 1s ease-in-out 3s infinite both;
}

/* ----------------------------------------------
 * Generated by Animista on 2021-5-5 12:17:48
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation pulsate-fwd
 * ----------------------------------------
 */
@-webkit-keyframes pulsate-fwd {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    50% {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}
@keyframes pulsate-fwd {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    50% {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}


</style>


